var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolasUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5474 16.5247C19.669 16.5247 21.3862 14.791 21.3862 12.6491C21.3862 10.5071 19.669 8.77344 17.5474 8.77344C15.4259 8.77344 13.7087 10.5071 13.7087 12.6491C13.7087 14.791 15.4259 16.5247 17.5474 16.5247ZM20.1797 17.632H19.8952C19.1823 17.978 18.3906 18.1857 17.5474 18.1857C16.7043 18.1857 15.916 17.978 15.1997 17.632H14.9152C12.7353 17.632 10.9668 19.4176 10.9668 21.6184V22.6149C10.9668 23.5319 11.7037 24.2759 12.612 24.2759H22.4829C23.3912 24.2759 24.1281 23.5319 24.1281 22.6149V21.6184C24.1281 19.4176 22.3595 17.632 20.1797 17.632Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolasUser);
export default __webpack_public_path__ + "static/media/volas-user.3853bef4959e4cc1d04683207824d557.svg";
export { ForwardRef as ReactComponent };